module.exports = "https://r.nearpod.com/assets/media/image/contact_icon-6fc47e522f831dc7337f31fc1b5a76a3.svg";